import * as React from 'react'
import { nextFrame } from 'utils/dom'

interface useRootScrollProps {
  shouldScrollOnLoad?: boolean
}
export function useRootScroll({ shouldScrollOnLoad }: useRootScrollProps = {}) {
  const handleScrollToRoot = React.useCallback(() => {
    const rootElement = document.querySelector('[data-layout="root"]') || window

    if (!rootElement) {
      return
    }

    rootElement.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  function handleScrollToRootOnNextFrame() {
    nextFrame(() => handleScrollToRoot())
  }

  React.useEffect(() => {
    if (!shouldScrollOnLoad) {
      return
    }

    handleScrollToRoot()
  }, [shouldScrollOnLoad, handleScrollToRoot])

  return {
    handleScrollToRoot,
    handleScrollToRootOnNextFrame,
  }
}
